/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-09-13 19:51:53
 */
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import { Button, Switch } from 'antd'
import { useAppSelector, useAppDispatch, useUserId } from '../../../app/hooks'
import {
  fetchGroupDeparmentByLevel,
  fetchGroupInfo
} from '../../../actions/group'
import CONFIG from '../../../constants/config'
import sensors from '../../../utils/sensors'
import { useDepartmentAuth } from '../../../app/authPolicyHooks'

interface IModalFooterProps {
  onCancel: () => void
  onOk: () => void
  onlyInGroup?: boolean //仅显示当前在团队成员
  onIsOnlyInGroupChange: () => void
}
const ModalFooter: React.FC<IModalFooterProps> = (props) => {
  const { onCancel, onOk, onlyInGroup } = props

  const isOnlyInGroup = useAppSelector((state) => state.group.onlyInGroup) as
    | 0
    | 1
    | 2
  const groupID = useAppSelector((state) => state.group.groupId)
  const userID = useUserId()
  const dispatch = useAppDispatch()
  const departmentAuth = useDepartmentAuth()
  const fetchGroupInfoAction = (data) => dispatch(fetchGroupInfo(data))

  const fetchDepartment = useCallback(
    (enableQuitUser) => {
      if (departmentAuth === null) return
      const params = {
        groupID: groupID,
        userID: userID,
        enableQuitUser,
        departmentIDList: departmentAuth.departmentIDList,
        userIDList: departmentAuth.userIDList
      }
      return dispatch(fetchGroupDeparmentByLevel(params))
    },
    [groupID, userID, isOnlyInGroup, departmentAuth]
  )

  const onIsOnlyInGroupChange = useCallback((checked: boolean) => {
    props.onIsOnlyInGroupChange()
    fetchGroupInfoAction({
      group_id: localStorage.getItem('group_id'),
      only_in_group: checked
        ? CONFIG.onlyInGroup.ONLY_IN_GROUP
        : CONFIG.onlyInGroup.ALL
    })
    fetchDepartment(!checked)

    sensors.track('web_workgroup_filter_member_page_click', {
      clickItem: checked ? 'onJobSwitch' : 'offJobSwitch',
      pagePath: window.location.pathname,
      groupID: groupID
    })
  }, [])

  return (
    <div className="modal-footer">
      {!onlyInGroup && (
        <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
          <Switch
            size="small"
            checked={isOnlyInGroup === 2}
            onChange={onIsOnlyInGroupChange}
          />
          <span style={{ marginLeft: '10px' }}>仅显示当前在团队的成员</span>
        </div>
      )}
      <div>
        <Button onClick={onCancel}>取消</Button>
        <Button style={{ marginLeft: 8 }} type="primary" onClick={onOk}>
          确定
        </Button>
      </div>
    </div>
  )
}

export default ModalFooter
